<template>
  <el-container style="height: 100%">
    <el-header
      :style="'margin-bottom:' + headerBottom + 'px'"
      class="animate__animated animate__fadeIn"
    >
      <!-- <h1 class="animate__animated animate__swing logo" @click="toWeb">信息学基地</h1> -->
      <!-- logo -->
      <div class="logo">
        <a href="https://www.singera.cn/#/home"><img src="../../assets/img/logo.png" alt="" /></a>
        <!-- <a href="https://t.singera.cn/#/home"
          ><img src="../../assets/img/logo.png" alt=""
        /></a> -->
      </div>
      <el-menu
        :default-active="this.$route.path"
        class="el-menu-demo"
        mode="horizontal"
        :router="true"
        active-text-color="#6495ED"
        @select="handleSelect"
      >
        <el-menu-item
          :index="item.path"
          v-for="item in menulist"
          :key="item.id"
        >
          <template slot="title">
            <div class="tag">
              <i :class="item.icon"></i>
              <span>{{ item.authName }}</span>
            </div>
          </template>
        </el-menu-item>
      </el-menu>
      <!-- 移动端 -->
      <div v-if="menuHiddenVisiable">
        <el-menu
          :default-active="activeIndex"
          class="animate__animated animate__fadeInDown el-menu-hidden"
          background-color="#545c64"
          router
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item
            :index="item.path"
            v-for="item in menulist"
            :key="item.id"
            style="lineheight: 56px"
          >
            <template slot="title">
              <i :class="item.icon"></i>
              <!--                文本-->
              <span>{{ item.authName }}</span>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="menu-expend" @click="menuExpend">
        <i class="el-icon-menu"></i>
      </div>

      <!-- 右侧下拉菜单 -->
      <div class="button">
        <div v-if="isLogin">
          <el-dropdown trigger="click">
            <img src="../../assets/img/userImg.png" alt="" class="head-img" />
            <span class="el-dropdown-link head-name">
              {{ this.userName
              }}<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <router-link
                  :to="{ name: 'center', query: { user_id: userName } }"
                  ><i class="el-icon-s-custom"></i>学习情况</router-link
                >
              </el-dropdown-item>
              <el-dropdown-item v-if="role.indexOf('administrator') > -1">
                <div @click="toAdmin()" style="color: #999">
                  <i class="el-icon-s-tools"></i>管理
                </div>
              </el-dropdown-item>
              <el-dropdown-item>
                <div @click="logout()" style="color: #999">
                  <i class="el-icon-warning"></i>退出登录
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-else>
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              登录<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a href="https://www.singera.cn/#/login">登录</a>
                <!-- <a href="https://t.singera.cn/#/login">登录</a> -->
              </el-dropdown-item>
              <el-dropdown-item>
                <a href="https://www.singera.cn/#/register">注册</a>
                <!-- <a href="https://t.singera.cn/#/register">注册</a> -->
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
  </el-container>
</template>

<script>
import { loginStatus, logout } from "../../util/home.js";
export default {
  name: "headerbar",
  inject: ["reload"],
  data() {
    return {
      menulist: [
        {
          id: 1,
          authName: "首页",
          path: "/home",
          icon: "el-icon-s-home",
        },
        {
          id: 2,
          authName: "题库",
          path: "/question",
          icon: "el-icon-collection",
        },
        {
          id: 3,
          authName: "状态",
          path: "/status",
          icon: "el-icon-odometer",
        },
        {
          id: 4,
          authName: "排名",
          path: "/ranking",
          icon: "el-icon-data-analysis",
        },
        {
          id: 5,
          authName: "竞赛",
          path: "/match",
          icon: "el-icon-trophy",
        },
        {
          id: 6,
          authName: "题单",
          path: "/test",
          icon: "el-icon-edit-outline",
        },
        {
          id: 7,
          authName: "初赛",
          path: "/preliminary",
          icon: "el-icon-document",
        },
      ],
      activeIndex: "",
      isLogin: false,
      userName: "",
      role: [],
      menuHiddenVisiable: false,
      headerBottom: 0,
      screenWidth: null,
    };
  },
  watch: {
    screenWidth: {
      handler: function (val, oldVal) {
        if (val > 860) {
          this.menuHiddenVisiable= false;
          this.headerBottom = 0;
        }
      },

      immediate: true,
    },
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      loginStatus()
        .then((res) => {
          if (!res.data.status) {
            let isLog = res.data.data;
            if (Object.keys(isLog).length > 0) {
              this.isLogin = true;
              this.userName = isLog.username;
              this.role = isLog.role;
              let loginInfo = {
                LoginName: this.userName,
                role: this.role,
              };
              this.cookie.setCookie(loginInfo, 1);
            } else {
              this.cookie.clearCookie("LoginName");
              this.cookie.clearCookie("role");
              this.isLogin = false;
            }
          } else {
            this.cookie.clearCookie("LoginName");
            this.cookie.clearCookie("role");
            this.isLogin = false;
          }
        })
        .catch(() => {
          this.$message.error("服务器异常，请稍后再试");
        });
    },
    handleSelect(key, keyPath) {
      window.sessionStorage.setItem("activeIndex", key);
      if (key === this.$route.path) {
        this.reload();
      }
    },
    toAdmin() {
      // window.open("http://t.admin.singera.cn/", "_blank");
      window.open("http://admin.singera.cn/", "_blank");
    },
    logout() {
      logout()
        .then((res) => {
          console.log(res.data.status);
          if (!res.data.status) {
            this.cookie.clearCookie("role");
            this.cookie.clearCookie("LoginName");
            this.cookie.clearCookie("singera_com_uid");
            this.cookie.clearCookie("isLogin");
            this.isLogin = false;
            this.$message({
              message: "已退出",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch(() => {
          this.$message.error("退出失败");
        });
    },
    // 展开菜单栏
    menuExpend() {
      this.menuHiddenVisiable = !this.menuHiddenVisiable;
      if (this.menuHiddenVisiable === true) {
        this.headerBottom = 360;
      } else {
        this.headerBottom = 0;
      }
    },
    // toWeb() {
    //   // window.location = "https://www.singera.cn/#/home";
    //   window.location = "https://t.singera.cn/#/home";
    // }
  },
};
</script>

<style lang='less' scoped>
/deep/.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  font-size: 18px;
  display: inline-block;
  vertical-align: top;
  margin-top: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.el-header {
  transition: 0.2s;
  // width: 100%;
  height: 80px !important;
  background: linear-gradient(#128dec, #00b4ff);
  box-shadow: 0 5px 10px rgba(50, 129, 255, 0.5);
}
/deep/.el-menu {
  width: 70%;
  height: 80px !important;
  overflow: hidden !important;
  background-color: none !important;
  display: inline-block;
}
/deep/.el-menu-item {
  font-size: 18px;
  border: none;
  line-height: 80px;
}
.el-menu--horizontal > .el-menu-item {
  color: #fff;
}
.el-menu-item i {
  color: #fff;
}
.el-menu-item.is-active i {
  color: inherit;
}
.is-active {
  border: none;
  // background: #fff;
  // border-radius: 20px;
  .tag {
    background: #fff;
    display: inline-block;
    width: 100px;
    height: 36px;
    text-align: center;
    border: none;
    line-height: 36px;
    border-radius: 20px;
  }
}
el-main {
  margin: 20px 0;
}
a {
  display: inline-block;
  color: #999;
  text-decoration: none;
}
.head-img {
  width: 40px;
  height: 40px;
  display: inline-block;
  margin: 10px 0 10px 0;
}
.logo {
  color: #fff;
  margin-right: 20px;
  float: left;
  img {
    display: inline-block;
    vertical-align: top;
    margin-top: 20px;
  }
}

.logo:hover {
  cursor: pointer;
}
.button {
  margin: 6px 10px 10px 0;
  float: right;
}
/deep/.el-menu--horizontal > .el-menu-item.is-active {
  border: none;
}

// 响应式
.el-menu {
  flex-shrink: 0;
}
.menu-expend {
  display: none !important;
}
.el-menu-hidden {
  /*display: none;*/
  position: absolute;
  top: 80px;
  left: 0;
  border-top: 1px solid #ccc;
  border-right: none;
  width: 100%;

  .el-menu-item {
    border-bottom: 1px solid #ccc;
    line-height: 56px!important;
  }
}
@media (min-width: 860px) and (max-width: 1200px) {
  .head-img {
    display: none;
  }
}
@media screen and (max-width: 860px) {
  .el-header {
    height: 65px;
  }
  /deep/.el-menu {
    height: auto !important;
  }
  .el-menu /deep/ .el-menu-item {
    background-color: rgba(0, 0, 0, 0.3) !important;
  }

  .el-menu-demo {
    display: none;
  }

  .title {
    width: 100%;
    background-position-x: center;
  }

  .menu-expend {
    display: block !important;
    position: absolute;
    top: 18px;
    left: 150px;
    font-size: 20px;
    line-height: 45px;
    color: #fff;
    margin-left: 70px;
  }

  .menu-expend:hover {
    color: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
  .button {
    margin: 5px 10px 10px 0;
  }
  // .title {
  //   background-position-y: 0;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue